import { gql, useMutation } from "@apollo/client";
import { User } from "../types";

const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      name
      firstName
      lastName
    }
  }
`;

export interface UpdateUserProfileData {
  updateUserProfile: Pick<User, "name" | "firstName" | "lastName">;
}

export interface UpdateUserProfileVars {
  input: {
    name: string;
    firstName: string;
    lastName: string;
  };
}

export const useUpdateUserProfileMutation = () =>
  useMutation<UpdateUserProfileData, UpdateUserProfileVars>(
    UPDATE_USER_PROFILE
  );
